<template>
  <ZccSelect
    class="appearance-none indent-96 bg-transparent h-full w-full"
    :class="modelValue"
    :model-value="modelValue"
    @update:model-value="(value) => emit('update:modelValue', value)"
    :options="Array.isArray(data) ? data : []"
    :loading="loading || isLoading"
  >
  </ZccSelect>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, watch, onMounted } from 'vue';
import { useListScheduleStateSelectOptions } from '@planbord/queries/planbord-api';
import { ZccSelect } from '@planbord/ui/components';

const emit = defineEmits<{ (e: 'update:modelValue', value: unknown): void }>();
const props = defineProps<{
  label?: string;
  loading?: boolean;
  modelValue: unknown;
}>();

const { data, isLoading } = useListScheduleStateSelectOptions();

function setDefaultValue() {
  if (!isLoading.value && data.value && !props.modelValue) {
    emit('update:modelValue', data.value[0].Id);
  }
}

watch(isLoading, setDefaultValue);
onMounted(setDefaultValue);
</script>
